import "./App.css";

export default function Home() {

//   const detectDevice = () =>{
//     const userAgent = navigator.userAgent.toLowerCase();
//     return /android|iphone|ipad|ipod|opera mini|iemobile|wpdesktop/.test(userAgent);
// }
// const isMobile = detectDevice();

// console.log(isMobile);

  return (
    <div className='page'>
      <div className="img-container">
        <img src='/pc.png' alt="乐卡" />
      </div>
       
    </div>
  );
}
